import { BarChart3, Boxes, ChevronRight, CreditCard, ExternalLink, LayoutDashboard, LogOut, Mail, PackageCheck } from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAdmin } from "../context/AdminContext.jsx";

const links = [
  { to: "/admin", end: true, label: "Vue d’ensemble", icon: LayoutDashboard },
  { to: "/admin/commandes", label: "Commandes", icon: PackageCheck },
  { to: "/admin/produits", label: "Produits", icon: Boxes },
  { to: "/admin/paiements", label: "Paiements", icon: CreditCard },
  { to: "/admin/messages", label: "Messages", icon: Mail },
];

export function AdminLayout() {
  const { user, logout } = useAdmin();
  const navigate = useNavigate();
  async function handleLogout() {
    await logout();
    navigate("/admin/connexion", { replace: true });
  }

  return <div className="admin-shell">
    <aside className="admin-sidebar">
      <NavLink className="admin-brand" to="/admin"><span className="brand__mark"><span /></span><span><b>Eco</b>timbre<small>Administration</small></span></NavLink>
      <nav aria-label="Navigation administration">{links.map(({ to, end, label, icon: Icon }) => <NavLink key={to} to={to} end={end}><Icon /><span>{label}</span><ChevronRight /></NavLink>)}</nav>
      <div className="admin-sidebar__footer">
        <a href="/" target="_blank" rel="noreferrer"><ExternalLink />Voir le site</a>
        <button type="button" onClick={handleLogout}><LogOut />Déconnexion</button>
      </div>
    </aside>
    <section className="admin-workspace">
      <header className="admin-topbar"><div><BarChart3 /><span>Pilotage en temps réel</span></div><div className="admin-user"><span>{user?.name?.charAt(0) || "A"}</span><div><strong>{user?.name || "Administrateur"}</strong><small>{user?.email}</small></div></div></header>
      <main className="admin-main"><Outlet /></main>
    </section>
  </div>;
}
